import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ensureUser } from "../../utils/userUtils";


const BeginButton = ({ mode }: { mode: string }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Handle navigation based on onboarding status
  const handleNavigation = useCallback(async () => {
    await ensureUser(mode as "light" | "dark", "en");
    if (mode === "dark") {
      navigate("/dark-warning");
    } else {
      navigate("/questionnaire");
    }
  }, [navigate, mode]);

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleNavigation();
      }
    },
    [handleNavigation]
  );

  return (
    <div
      className="
        relative
        w-24 h-24 sm:w-32 sm:h-32 md:w-36 md:h-36
        rounded-full
        bg-black/20
        flex items-center justify-center
      "
    >
      {/* Inner circle container */}
      <div className="w-[calc(100%)] h-[calc(100%)] rounded-full flex items-center justify-center">
        <div className="relative flex items-center justify-center">
          {/* Pulsing animation circle */}
          <div
            className="
            absolute
            w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32
            rounded-full
            bg-sangati-green
            border-2 border-sangati-orange
            custom-ping
            z-10
          "
          />

          {/* Main button */}
          <button
            id="landing-begin-btn"
            onClick={handleNavigation}
            onKeyDown={handleKeyDown}
            className="
              relative z-20
              w-[120px] h-[120px] sm:w-32 sm:h-32 md:w-36 md:h-36
              rounded-full
              bg-sangati-green
              border-2 border-sangati-orange
              flex items-center justify-center
              font-bold text-white
              text-lg sm:text-xl md:text-2xl
              uppercase
              cursor-pointer
              focus:outline-none focus:ring-2 focus:ring-sangati-orange focus:ring-offset-2
              hover:scale-105 active:scale-95
              transition-transform duration-200
            "
            aria-label={t("landingButton")}
            tabIndex={0}
          >
            {t("landingButton")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BeginButton;
